import { sendGAEvent } from '@next/third-parties/google';

const googleEventSearch = (searchTerm: string): any => {
  return sendGAEvent('event', 'search', {
    search_term: searchTerm,
  });
};

export default googleEventSearch;
